import React from "react";

export default class TooltipShop extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			height: 0
		}
	}

	ref = null
	componentDidMount() {
		const height = this.ref.clientHeight;
		this.setState({height})

	}

	render() {
		return (
			<div
				style={{ position: 'relative' }}
				onMouseEnter={() => this.setState({ show: true })}
				onMouseLeave={() => this.setState({ show: false })}
			>
				<div>
					{this.props.children}
				</div>
				<div ref={(divElement) => { this.ref = divElement }} style={{
					position: 'absolute',
					backgroundColor: '#000000',
					opacity: 0.85,
					color: '#FFFFFF',
					visibility: (this.state.show) ? 'visible' : 'hidden',
					padding: 5,
					borderRadius: 5,
					zIndex: 1000,
					bottom: (0 - this.state.height),
					left: 20
				}}>
					{this.props.text}
				</div>
			</div>
		)
	}
}